import { useQuery } from '@tanstack/react-query';

import axiosInstance from 'src/utils/axios';

export const getRunConfig = async (runConfigId: string | undefined) => {
  if (!runConfigId) {
    throw new Error('Run Config ID is required');
  }
  const response = await axiosInstance.get(`/run_config/${runConfigId}`);
  return response.data;
};

export const useRunConfig = (runConfigId: string | undefined) =>
  useQuery({
    queryKey: ['run-config', runConfigId],
    queryFn: () => getRunConfig(runConfigId),
    enabled: !!runConfigId,
  });
